const applicantListing =  function () {

    var ApplicantActionListUi = function () {
        this.applicantCheckboxes   = $('.applicantToMailingListCheck');
        this.applicantCheckboxesSelector = '.applicantToMailingListCheck';
        this.actionList            = $('#applicantListSelectMailingList');
        this.applyApplicantsButton = $('.applicantListMailingApplyApplicantsButton');
        this.emptyListButton       = $('.applicantListMailingDeleteButton');
        this.applicants            = [];
        this.selectMailingList     = $('.selectMailingList');
    };

    /**
     * Registriert alle notwendigen Event-Handler.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.initHandlers = function () {

        this.actionList.on('change',
                $.proxy(this.handleActionListChange, this));

        this.applyApplicantsButton.on('click',
                $.proxy(this.handleApplyApplicantsClick, this));

        this.emptyListButton.on('click',
                $.proxy(this.handleEmptyListClick, this));

        $(document).on('ifClicked', this.applicantCheckboxesSelector,
                $.proxy(this.handleApplicantChange, this));

        if (this.selectMailingList.val() === '0') {  // no action list is selected, so we have to hide the checkboxes
            this.hideCheckboxes();
        } else { // an action list is selected, so the checkboxes are visible and we have to trigger the selected option to get the associated data via ajax
            this.selectMailingList.change();
        }

        return this;
    };

    /**
     * Sets the active action list in the session.
     */
    ApplicantActionListUi.prototype.setActiveActionListInSession = function () {
        $.ajax({
            url: '/applicant/action-list/set-active-action-list',
            data: {
                actionListId: $('.selectMailingList').val()
            },
            method: 'POST'
        });
    };

    /**
     * Handler fuer eine Aenderung der gewaehlten Aktionsliste.
     */
    ApplicantActionListUi.prototype.handleActionListChange = function () {
        this.setActiveActionListInSession();

        if (!this.hasListSelected()) {
            this.hideCheckboxes();
        } else {
            this.getApplicants(function (data) {
                this.applicants = data;
                this.uncheckAllCheckboxes()
                    .checkCheckboxes()
                    .showCheckboxes();
            }.bind(this));
        }
    };

    /**
     * Handler fuer das Uebernehmen der gefundenen Bewerber auf die gewaehlte
     * Aktionsliste.
     */
    ApplicantActionListUi.prototype.handleApplyApplicantsClick = function () {

        if (this.hasListSelected()) {
            this.applyApplicants();
        }
    };

    /**
     * Handler fuer das Leeren der gewaehlten Aktionsliste.
     */
    ApplicantActionListUi.prototype.handleEmptyListClick = function () {

        if (this.hasListSelected()) {
            this.emptyList();
        }
    };

    /**
     * Handler fuer die Aenderung einer Bewerber-Auswahl.
     */
    ApplicantActionListUi.prototype.handleApplicantChange = function (e) {

        var el = $(e.currentTarget);
        var id = el.val();

        if (!el.is(':checked')) {
            this.addApplicant(id, function (success) {
                if (!success) {
                    el.prop('checked', false);
                }
            });
        } else {
            this.removeApplicant(id, function (success) {
                if (!success) {
                    el.prop('checked', true);
                }
            });
        }
    };

    /**
     * Deselektiert alle Checkboxen, die fuer die Aktionslisten relevant sind
     * (Bewerber).
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.uncheckAllCheckboxes = function () {
        this.applicantCheckboxes.iCheck('uncheck');

        return this;
    };

    /**
     * Markiert die Checkboxen der in den uebergebenen Daten enthaltenen
     * Bewerber.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.checkCheckboxes = function () {

        var self = this;

        this.applicantCheckboxes.each(function (idx, el) {

            var applicantId = el.value;

            $.each(self.applicants, function (idx, curId) {

                if (curId == applicantId) {
                    $(el).iCheck('check');

                    // entspricht hier einem break
                    return false;
                }
            });
        });

        return this;
    };

    /**
     * Holt die Ansprechpartner-IDs fuer die gewaehlte
     * Aktionsliste.
     *
     * @param {Function} cb Callback, wird mit dem Ergebnis als erstem Parameter
     *                      aufgerufen
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.getApplicants = function (cb) {

        var applicantIds = this.applicantCheckboxes.map(function (idx, el) {
            return this.value;
        }).get().join();

        if (applicantIds === '') {
            applicantIds = 0;
        }

        $.ajax({
            url: '/applicant/action-list/applicants/' + this.actionList.val() + '/' + applicantIds,
            method: 'GET',
            loadingOverlay: true
        }).done(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                cb(data.applicants);
            } else {
                cb([]);
            }
        });

        return this;
    };

    /**
     * Eine Firma zur ausgewaehlten Aktionsliste hinzufuegen.
     *
     * @param {Number} applicantId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.addApplicant = function (applicantId, cb) {

        $.post('/applicant/action-list/add-applicant/' + applicantId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
        });

        return this;
    };

    /**
     * Einen Bewerber von der ausgewaehlten Aktionsliste entfernen.
     *
     * @param {Number} applicantId
     * @param {Function} cb Callback, wird mit Erfolgsstatus als Parameter
     *                      aufgerufen
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.removeApplicant = function (applicantId, cb) {

        $.post('/applicant/action-list/remove-applicant/' + applicantId, {
            listId: this.actionList.val()
        }, function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            cb(data.success);
        });

        return this;
    };

    /**
     * Alle gefundenen Bewerber zur Aktionsliste hinzufuegen.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.applyApplicants = function () {

        $.ajax({
            url: '/applicant/action-list/apply-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {

                var self = this;

                self.applicants = [];

                data.applicantIds.forEach(function (id) {
                    self.applicants.push(id);
                });

                this.checkCheckboxes();
            }
        }, this));

        return this;
    };

    /**
     * Leert die ausgewaehlte Aktionsliste von allen Bewerbern.
     *
     * @returns {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.emptyList = function () {

        $.ajax({
            url: '/applicant/action-list/empty-all/' + this.actionList.val(),
            method: 'POST',
            loadingOverlay: true
        }).done($.proxy(function (data) {
            var blockLoader = new Esearcher.BlockLoader();
            blockLoader.process(data);
            if (data.success) {
                this.applicants = [];
                this.uncheckAllCheckboxes();
            }
        }, this));

        return this;
    };

    /**
     * Gibt zurueck, ob eine Aktionsliste ausgewaehlt wurde.
     *
     * @returns {Boolean}
     */
    ApplicantActionListUi.prototype.hasListSelected = function () {
        return this.actionList.val() !== '0';
    };

    /**
     * Zeigt die Checkboxen vor den Bewerbern an.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.showCheckboxes = function () {
        this.applicantCheckboxes.removeClass('no-ready');
        this.applicantCheckboxes.parent().filter('.checkbox-square').show();

        parseCheckboxes();
        return this;
    };

    /**
     * Versteckt die Checkboxen vor Bewerbern.
     *
     * @return {ApplicantActionListUi}
     */
    ApplicantActionListUi.prototype.hideCheckboxes = function () {
        this.applicantCheckboxes.addClass('no-ready');
        this.applicantCheckboxes.parent().filter('.checkbox-square').hide();

        parseCheckboxes();
        return this;
    };

    var applicantActionList = new ApplicantActionListUi();

    applicantActionList.initHandlers();
};

export default applicantListing;
